export default __webpack_public_path__ + "static/media/5.14ae80de.svg";